import React from "react";
import SEO from "../../components/SEO";
import Content from "./components/Content";

function Home() {
  return (
    <>
      <SEO />
      <Content />
    </>
  );
}

export default Home;
